<template>
  <div>
  <div 
    v-if="!json.init"
    class="spe_booklist"
    id="book"
    :style="{
      'padding': `0 ${propData.commonStyle.margin}px`,
      'background-color': propData.commonStyle.usePageBackgroundColor ? propData.commonStyle.bgColor : propData.commonStyle.backgroundColor,
      'background-image': `url(${propData.commonStyle.backgroundType == 2 ? propData.commonStyle.backgroundImage:''})`
    }"
    :ddt-area="`component_${json.floorId}_书单组件`"
    ddt-expose="on"
  >
    <div 
      v-if="propData.header.type==1"
      class="title" 
      :style="{
        'color': propData.header.titleColor || propData.header.titleDefaultColor,
        'background-color': propData.header.backgroundColor || propData.header.backgroundDefaultColor
      }"
      @click="$sys.dict.href(propData.header.jumpUrl)"
      :data-area="pt()"
      :data-pos="`component_${json.floorId}_书单组件.标题_点击跳转`"
      :data-desc="propData.header.title"
      :dd_name="`${pt()}.component_${json.floorId}_书单组件.标题_点击跳转.${propData.header.title}`"
      :ddt-click="`${pt()}.component_${json.floorId}_书单组件.标题_点击跳转.${propData.header.title}`"
      :ddt-pit="`标题_点击跳转`"
      :ddt-src="propData.header.title"
      ddt-expose="on"
    >
      {{ propData.header.title }}
    </div>
    <img v-else-if="propData.header.type==2" class="title_img" @click="$sys.dict.href(propData.header.jumpUrl)" :src="propData.header.titleImage" alt="">
    <div class="content">
      <div 
        class="bookname"
        :class="propData.columnsType==2?'three_pit_bookname':(propData.columnsType==3 ? 'four_pit_bookname' : '')"
        v-for="(item, index) in propData.bookList" 
        :key="index"
        @click="$sys.dict.href(item.jumpUrl)"
        :data-area="pt()"
        :data-pos="`component_${json.floorId}_书单组件.坑位${index + 1}_点击跳转`"
        :data-desc="item.content"
        :dd_name="`${pt()}.component_${json.floorId}_书单组件.坑位${index + 1}_点击跳转.${item.content}`"
        :ddt-click="`${pt()}.component_${json.floorId}_书单组件.坑位${index + 1}_点击跳转.${item.content}`"
        :ddt-pit="`坑位${index + 1}_点击跳转`"
        :ddt-src="item.content"
        ddt-expose="on"
      >
        <div 
          class="words" 
          :style="{
            'color': propData.contentColor || propData.contentDefaultColor,
            'background-image': `url(${propData.contentBackgroundImg})`
          }">
          {{ item.content }}
        </div>
      </div>
    </div>
    <div 
      class="footer"
      v-if="propData.buttonInfo.type!=0"
      :style="{
        'color': propData.buttonInfo.contentColor || propData.buttonInfo.contentDefaultColor,
        'background-color': propData.buttonInfo.backgroundColor || propData.buttonInfo.backgroundDefaultColor
      }"
    >
      <div
        v-if="propData.buttonInfo.type==1"
        @click="$sys.dict.href(propData.buttonInfo.jumpUrl)"
        :data-area="pt()"
        :data-pos="`component_${json.floorId}_书单组件.文字footer_点击跳转`"
        :data-desc="propData.buttonInfo.content"
        :dd_name="`${pt()}.component_${json.floorId}_书单组件.文字footer_点击跳转.${propData.buttonInfo.content}`"
        :ddt-click="`${pt()}.component_${json.floorId}_书单组件.文字footer_点击跳转.${propData.buttonInfo.content}`"
        ddt-pit="文字footer_点击跳转"
        :ddt-src="propData.buttonInfo.content"
        ddt-expose="on"
      >
        <span>{{ propData.buttonInfo.content }}</span>
        <span class="arrow iconfont">&#xe669;</span>
      </div>
      <img
        v-if="propData.buttonInfo.type==2"
        @click="$sys.dict.href(propData.buttonInfo.jumpUrl)"
        class="img"
        :src="propData.buttonInfo.image"
        alt=""
        :data-area="pt()"
        :data-pos="`component_${json.floorId}_书单组件.图片footer_点击跳转`"
        :data-desc="propData.buttonInfo.image"
        :dd_name="`${pt()}.component_${json.floorId}_书单组件.图片footer_点击跳转.${propData.buttonInfo.image}`"
        :ddt-click="`${pt()}.component_${json.floorId}_书单组件.图片footer_点击跳转.${propData.buttonInfo.image}`"
        ddt-pit="图片footer_点击跳转"
        :ddt-src="propData.buttonInfo.image"
        ddt-expose="on"
      >
    </div>
  </div>
  <div v-else :style="{height:`${json.height}px`}"></div>
  </div>
</template>

<script>
export default {
  props: {
    json: {
      type: Object,
      default: () => {
        return {
        };
      }
    }
  },
  data() {
    return {
    }
  },
  inject: ['pt'],
  computed: {
    propData() {
      return this.json.data || {
        commonStyle: {},
        header: {},
        buttonInfo: {}
      }
    }
  }
}
</script>

<style lang="less" scoped>
.spe_booklist {
  background-size: 100% 100%;
  .title {
    height: .94rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: .34rem;
  }
  .title_img {
    height: .94rem;
    width: 100%;
  }
  .content {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    padding: 0 .14rem;

    .bookname {
      width: 50%;
      padding: .06rem;
      box-sizing: border-box;

      .words {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;        
        font-size: .26rem;
        height: .64rem;
        line-height: .64rem;
        text-align: center;
        background-size: 100% 100%;
        border-radius: 0.08rem;
        padding: 0 0.32rem;
      }
    }
    .three_pit_bookname {
      width: 33.3%;
    }

    .four_pit_bookname {
      width: 25%;
    }
  }
  .footer {
    height: .94rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: .26rem;
    .img {
      width: 100%;
      height: 100%;
    }
    /* 小箭头 */
    .arrow {
      font-size: .22rem;
    }
  }
}
</style>
